import React, {useEffect, useMemo, useRef, useState} from "react";
import './Input.scss';
import {Label, Message} from "semantic-ui-react";
import _ from "lodash";
import {parseFollowupConditions, parseFollowupReasons, renderFollowup, checkNumeric, inputBlur} from "../FieldsUtils";

const INVALID_CHARS = /[<>{}|`\\]/;

const Input = ({settings, handleChange, order, index, followupValue, subtype, placeholder, defaultValue = ""}) => {
  const [value, setValue] = useState(defaultValue);
  const [error, setError] = useState("");
  const followup_conditions = useMemo(() => parseFollowupConditions(settings), [settings]);
  const [followupValues, setFollowupValues] = useState({radio: followupValue.radio, text: followupValue.text});
  const followup_reasons = useMemo(() => parseFollowupReasons(settings), [settings]);

  const label = settings.get('question_text');
  const subtitle = settings.get('question_subtitle');

  const _subtype = ((typeof subtype !== "undefined") && (subtype === "1")) ? "number" : "text";

  const handleInputChange = (event) => {
    event.preventDefault();
    const _value = event.target.value;
    let hasError = "";
    if ((_subtype !== 'number')) {
      hasError = (!_.isEmpty(_value) && INVALID_CHARS.test(_value))
        ? "Invalid value"
        : "";
      setError(hasError);
    }
    setValue(_value);
    handleChange(index, _value, "", 'input', hasError);
  };

  const handleFollowupChange = (event, newValue, type) => {
    event.preventDefault();
    const _value = followupValues;
    _value[type] = newValue;
    setFollowupValues(_value);
    handleChange(index, value, _value, type);
  }

  return (<React.Fragment>
    <div className='questions-input'>
      <Label>{order}. {label}</Label>
      {subtitle && (
        typeof subtitle === 'string' && subtitle.includes('<')
          ? <p className="input-subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />
          : <p className="input-subtitle">{subtitle}</p>
      )}
      {(_subtype === 'text') &&
        <InputBox value={value} onChange={handleInputChange} placeholder={placeholder} />
      }
      {(_subtype === 'number') &&
        <input type="text" inputMode="text" className='input-field-input' value={value} onChange={handleInputChange}
               min='0.00'
               pattern="^(?:[\$\(\)%,\.\+-\d]*\d+)$"
               onKeyDown={checkNumeric}
               onBlur={(e) => inputBlur(e, setError)}
        />
      }
      {renderFollowup(settings, 'any', followup_conditions, followup_reasons, followupValues.radio, followupValues.text, order, handleFollowupChange)}
      {(error.length > 0) && <Message
        error
        list={[error]}
      />}
    </div>
  </React.Fragment>);
};

const InputBox = ({value, onChange, placeholder}) => {
  const textareaRef = useRef(null);
  const [currentValue, setCurrentValue ] = useState(value);

  useEffect(() => {
    textareaRef.current.style.height = "0px";
    const scrollHeight = textareaRef.current.scrollHeight;
    textareaRef.current.style.height = scrollHeight + "px";

    // Moving cursor to the end
    textareaRef.current.selectionStart = textareaRef.current.value.length;
    textareaRef.current.selectionEnd = textareaRef.current.value.length;
  }, [currentValue]);

  const handleChange = (event) => {
    setCurrentValue(event.target.value);
    onChange(event);
  }

  return (
    <textarea ref={textareaRef} inputMode="text" className="input-field-input" value={currentValue}
              onChange={handleChange} placeholder={placeholder} />
  );
}

export default Input;